module.exports = __webpack_public_path__ + "media/explosion-1.5805753f.webm";